import Marquee from "react-fast-marquee";
import { useLang } from "@/i18n";

const EditorialMarquee = () => {
  const { t } = useLang();
  const items = t("marquee.items");

  return (
    <div data-testid="marquee" className="py-10 border-y border-[#1d3a1f]/5 bg-[#fdfbf5] overflow-hidden">
      <Marquee speed={40} gradient={false} autoFill>
        {items.map((txt, i) => (
          <span key={i} className="mx-8 font-display font-extrabold text-[7vw] leading-none text-stroke flex items-center gap-8">
            {txt}
            <span className="text-[#d3a53a] text-[2vw]">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
};

export default EditorialMarquee;
